import { render, staticRenderFns } from "./AddressesTimelineItem.vue?vue&type=template&id=5f548c20&"
import script from "./AddressesTimelineItem.vue?vue&type=script&lang=js&"
export * from "./AddressesTimelineItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports